/**
 * 认证相关工具函数
 */

/**
 * 检查用户是否已登录
 * @returns {boolean}
 */
export function isLoggedIn() {
    return localStorage.getItem('isLoggedIn') === 'true';
}

/**
 * 获取当前登录用户信息
 * @returns {Object|null}
 */
export function getCurrentUser() {
    const userStr = localStorage.getItem('currentUser');
    return userStr ? JSON.parse(userStr) : null;
}

/**
 * 设置登录状态
 * @param {Object} user - 用户信息
 * @param {boolean} rememberMe - 是否记住我
 */
export function setLoginStatus(user, rememberMe = false) {
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('currentUser', JSON.stringify({
        username: user.username,
        loginTime: new Date().toISOString()
    }));
    
    if (rememberMe) {
        localStorage.setItem('rememberedUsername', user.username);
    } else {
        localStorage.removeItem('rememberedUsername');
    }
}

/**
 * 清除登录状态
 */
export function clearLoginStatus() {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('currentUser');
}

/**
 * 获取记住的用户名
 * @returns {string|null}
 */
export function getRememberedUsername() {
    return localStorage.getItem('rememberedUsername');
}

/**
 * 检查用户权限（简单版本）
 * @returns {boolean}
 */
export function hasPermission() {
    // 这里可以根据实际需求扩展权限检查逻辑
    return isLoggedIn();
}

/**
 * 路由守卫检查
 * @param {string} path - 需要检查的路径
 * @returns {boolean} - 是否需要登录
 */
export function requireAuth(path) {
    const authRequiredPaths = ['/myDeclare', '/my', '/orders'];
    return authRequiredPaths.some(authPath => path.startsWith(authPath));
}
